var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUserIcon = function SvgUserIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0C18.2895 0 21.7667 3.44034 21.7667 7.68404C21.7667 11.9277 18.2895 15.3681 14 15.3681C9.71049 15.3681 6.23328 11.9277 6.23328 7.68404C6.23328 3.44034 9.71049 0 14 0ZM14 2.56516C11.1429 2.56516 8.82659 4.85689 8.82659 7.68405C8.82659 10.5112 11.1429 12.8029 14 12.8029C16.8571 12.8029 19.1734 10.5112 19.1734 7.68405C19.1734 4.85689 16.8571 2.56516 14 2.56516Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.6875 28.7174C0.6875 21.4434 6.64763 15.5464 14 15.5464C21.3524 15.5464 27.3125 21.4434 27.3125 28.7174C27.3125 29.4257 26.732 30 26.0158 30C25.2997 30 24.7192 29.4257 24.7192 28.7174C24.7192 22.8599 19.92 18.1116 14 18.1116C8.08003 18.1116 3.28081 22.8599 3.28081 28.7174C3.28081 29.4257 2.70035 30 1.98416 30C1.26796 30 0.6875 29.4257 0.6875 28.7174Z",
    fill: "#333333"
  })));
};
export default SvgUserIcon;